import {
  FaFileAlt,
  FaFileContract,
  FaFileSignature,
} from "react-icons/fa";

const BASE = "/super-admin/cms";

export const SUPER_ADMIN_CMS_GROUP = {
  id: "cms_management",
  heading: "CMS Management",
  icon: FaFileAlt,
  items: [
    {
      id: "cms_dashboard",
      label: "CMS Dashboard",
      to: `${BASE}`,
      icon: FaFileAlt,
      end: true,
    },
    {
      id: "cms_terms",
      label: "Terms & Conditions",
      to: `${BASE}/terms`,
      icon: FaFileContract,
      end: true,
    },
    {
      id: "cms_about_us",
      label: "About Us",
      to: `${BASE}/pages/about-us`,
      icon: FaFileSignature,
      end: true,
    },
    {
      id: "cms_contact_us",
      label: "Contact Us",
      to: `${BASE}/pages/contact-us`,
      icon: FaFileSignature,
      end: true,
    },
    {
      id: "cms_privacy",
      label: "Privacy Policy",
      to: `${BASE}/pages/privacy-policy`,
      icon: FaFileSignature,
      end: true,
    },
    {
      id: "cms_refund",
      label: "Refund & Cancellation",
      to: `${BASE}/pages/refund-cancellation-policy`,
      icon: FaFileSignature,
      end: true,
    },
    {
      id: "cms_domain",
      label: "Domain Redirection",
      to: `${BASE}/pages/domain-redirection-policy`,
      icon: FaFileSignature,
      end: true,
    },
  ],
};

export const SUPER_ADMIN_CMS_ITEMS = SUPER_ADMIN_CMS_GROUP.items;

export const CMS_SLUG_TO_PAGE_TYPE = {
  "about-us": "ABOUT_US",
  "contact-us": "CONTACT_US",
  "privacy-policy": "PRIVACY_POLICY",
  "refund-cancellation-policy": "REFUND_POLICY",
  "domain-redirection-policy": "DOMAIN_REDIRECTION_POLICY",
};

export const isSuperAdminCmsPath = (pathname = "") =>
  pathname.startsWith(`${BASE}/`) || pathname === BASE;
